import { supabase } from './supabaseClient';
import { slugToSku } from './coreOrder';

export type StockBySku = Record<string, number>;

// A set (bundle) is not its own stocked SKU — it's available as many times
// as its scarcest component allows. Bundles come from core_product_bundles,
// so any new set gets its stock the same way.
export async function fetchPublicStock(): Promise<StockBySku> {
  const [{ data }, { data: bundles }] = await Promise.all([
    supabase.from('rxk_public_stock_v').select('sku, qty_available'),
    supabase.from('core_product_bundles_public_v').select('bundle_sku, component_sku, qty_per_bundle'),
  ]);
  const bySku: StockBySku = {};
  for (const row of (data as { sku: string; qty_available: number }[]) ?? []) {
    bySku[row.sku] = Number(row.qty_available);
  }
  const sets: StockBySku = {};
  for (const b of (bundles as { bundle_sku: string; component_sku: string; qty_per_bundle: number }[]) ?? []) {
    const possible = Math.floor((bySku[b.component_sku] ?? 0) / Math.max(1, Number(b.qty_per_bundle) || 1));
    sets[b.bundle_sku] = Math.min(sets[b.bundle_sku] ?? Infinity, possible);
  }
  return { ...bySku, ...sets };
}

export function stockForSlug(slug: string, bySku: StockBySku): number | null {
  const sku = slugToSku(slug);
  if (!sku) return null;
  return bySku[sku] ?? 0;
}
